// frontend/src/DataManagementPage.js
import React, { useState } from 'react';
import './App.css';
import DataView from './DataView';
import DataReview from './DataReview';

function DataManagementPage({ directories = [], handleLogout }) {
    const [activeTab, setActiveTab] = useState('dataView'); // 'dataView' | 'dataReview'

    const renderActiveTab = () => {
        switch (activeTab) {
            case 'dataView':
                return (
                    <DataView
                        directories={directories}
                        handleLogout={handleLogout}
                    />
                );
            case 'dataReview':
                return <DataReview handleLogout={handleLogout} />;
            default:
                return (
                    <DataView
                        directories={directories}
                        handleLogout={handleLogout}
                    />
                );
        }
    };

    return (
        <div className="config-section-container">
            <div className="config-tabs">
                <button
                    className={`config-tab ${activeTab === 'dataView' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dataView')}
                >
                    Data View
                </button>
                <button
                    className={`config-tab ${activeTab === 'dataReview' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dataReview')}
                >
                    Collection Management
                </button>
            </div>
            <div className="config-page-area">
                {renderActiveTab()}
            </div>
        </div>
    );
}

export default DataManagementPage;
